'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isComponent;

var _reactIs = require('react-is');
/**
 * Return an indicator as to whether the supplied parameter is a 
 * react component (true) or not (false).
 *
 * @private
 */


function isComponent(comp) {
  // NOTE: Our unit test checks all three forms of Component creation:
  //       - Stateless Functional Component
  //       - Class Component (extending from React.Component)
  //       - Legacy React.createClass()
  return (0, _reactIs.isValidElementType)(comp);
}